export default __webpack_public_path__ + "static/media/ppv-app-background.b61cff99.png";